module.exports = __webpack_public_path__ + "img/it.d0e633a3.jpeg";